import * as angular from 'angular';

function filterFunction() {
    var sectionsCount = 4;
    var sectionLength = 4;
    var numberLength = sectionLength * sectionsCount;

    return function (input: string, prefix: string) {
        if (!input) {
            return null;
        }

        if (input.length !== numberLength) {
            throw new Error('Invalid card number: ' + input);
        }

        return prefix + input.substring(numberLength - sectionLength);
    };
}

angular
    .module('app.common')
    .filter('cardNumber', [filterFunction]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/card-number.filter.ts